<template>
	<vxe-modal v-model="showFlag" title="修改最小流量阀值"
						:destroy-on-close="true" width="60%" height="640px"
						 remember :esc-closable="false" show-footer>
			<vxe-table border resizable show-overflow :data="dataList"  max-height="500"
							:edit-config="{trigger: 'click', mode: 'cell'}" size="small">
				<vxe-column  field="meterApid" title="给水号"></vxe-column>
				<vxe-column  field="monitorName" title="监控点名称"></vxe-column>
				<vxe-column  field="monitorAddress" title="监控点地址"></vxe-column>
				<vxe-column  field="caliber" title="水表口径"></vxe-column>
				<vxe-column  field="meterStatus" title="状态" :formatter="getMeterStatus"></vxe-column>
				<vxe-column  field="overflow" title="最小流量阀值" :edit-render="{}">
					<template #edit="{ row }">
						<vxe-input v-model="row.overflow" type="number" placeholder="请输入最小流量阀值" min="0"></vxe-input>
					</template>
				</vxe-column>
			</vxe-table>
			<template #footer>
				<div class="drawerFooter">
				    <a-button size="small" icon="close" @click="onClose(false)" style="margin-right: 0.625rem;">取 消</a-button>
				    <a-button size="small"  icon="check" type="primary" @click="onSubmit" :loading="submiting">提 交</a-button>
				</div>
			</template>
	</vxe-modal>
</template>

<script>
	export default {
		data(){
			return {
				showFlag:false,
				dataList:[],
				submiting:false,
			}
		},
		methods: {
			onClose(flag){
				this.showFlag = false;
				this.dataList = [];
				if(flag){
					this.$emit('doRefresh');
				}
			},
			onSubmit(){
				this.submiting = true;
				let temp = JSON.stringify(this.dataList);
				let url = this.Api.getLastUrl(this.Api.METER_MONITOR_EDIT_OVERFLOW_URL);
				this.Api.fetchPostWithJson(url,temp).then((data)=>{
					this.submiting = false;
					let code = data.data.code;
					let result = data.data.result;
					let msg = data.data.message;
					if(code == this.Api.HTTP_OK_CODE){
						this.$message.success('修改成功');
						this.onClose(true);
					}else{
						this.$message.error(msg);
					}
				}).catch((error)=>{
					this.submiting = false;
					console.log(error);
				});
				
			},
			getMeterStatus({cellValue}){
				if(cellValue == '1'){
					return "正常";
				}else{
					return "无链接";
				}
			},
			showView(list){
				this.showFlag = true;
				this.dataList = this.Config.deepClone(list);
			},
		},
	}
</script>

<style>
</style>
